import { render, staticRenderFns } from "./MarketingContent.vue?vue&type=template&id=ebf5a2c2&scoped=true&"
import script from "./MarketingContent.vue?vue&type=script&lang=js&"
export * from "./MarketingContent.vue?vue&type=script&lang=js&"
import style0 from "./MarketingContent.vue?vue&type=style&index=0&id=ebf5a2c2&prod&lang=scss&"
import style1 from "./MarketingContent.vue?vue&type=style&index=1&id=ebf5a2c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf5a2c2",
  null
  
)

export default component.exports